export const calcTotalSales = (orders) => {
  if (!orders) return 0;
  return orders.reduce((total, current) => total + Number(current.balanceDue), 0);
};
